import type { Point } from 'geojson';

export type TAPlan = {
    id: number;
    detailsPath: string;
    typeOfWork: string;
    trafficConsequence: string;
    validFrom: string;
    validTo?: string;
    locationDescription: string;
    wgs84Position: Point;
    status: TAPlanStatus;
    statusText: string;
    affectedTrafficTypes: string[];
    affectedTrafficTypesDisplay: string;
    importedTime: string;
};

export enum TAPlanStatus {
    Coming = 2,
    Current = 3,
    RecentlyCompleted = 4,
}
